import { ThingsCurrentStates } from './thingsCurrentState';
export class ThingStatus{
    statusId: string;
    displayname: string;
    currentState: Array<Map<string, [string]>>;
    topic: string;
    accessoryIdentifier: string;
    thingMacId: string;
    hasStatusImage: boolean;
    iconType: string;
    linkIconType: string;
    linkDisplayName: string;
    constructor(statusId: string,
        displayname: string,
        currentState: Array<Map<string, [string]>>,
        topic: string,
        accessoryIdentifier: string,
        thingMacId: string,
        hasStatusImage: boolean,
        iconType: string,
        linkIconType: string,
        linkDisplayName: string){
            this.statusId = statusId;
            this.displayname = displayname;
            this.currentState = currentState;
            this.topic = topic;
            this.accessoryIdentifier = accessoryIdentifier;
            this.thingMacId = thingMacId;
            this.hasStatusImage = hasStatusImage;
            this.iconType = iconType;
            this.linkIconType = linkIconType;
            this.linkDisplayName = linkDisplayName;
        }
}